import axios from 'axios'
import { defineStore } from 'pinia'
export const shortcutStore = defineStore('shortcuts', {
    state: () => ({
        favorites: [],
        organizations: [],
        membershipOrganizations: [],
        employerOrganizations: [],
        loading: false,
    }),

    actions: {
        fetchShortcuts() {
            this.loading = true
            return axios
                .get(route('api.profile.shortcuts'))
                .then(({ data }) => {
                    this.favorites = data.favorites
                    this.organizations = data.organizations
                    this.membershipOrganizations = data.membershipOrganizations
                    this.employerOrganizations = data.employerOrganizations
                })
                .finally(() => {
                    this.loading = false
                })
        },

        deleteFavorite(model) {
            return axios
                .post(route('api.profile.favorites.delete'), {
                    model_id: model.id,
                    model_class: model.modelClass,
                })
                .then(() => {
                    this.favorites = this.favorites.filter(
                        (f) => f.id !== model.id
                    )
                })
        },

        addFavorite(model) {
            return axios
                .post(route('api.profile.favorites.add'), {
                    model_id: model.id,
                    model_class: model.modelClass,
                })
                .then(() => {
                    this.favorites.push(model)
                })
        },
    },
})
